// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_NotesList_wrapper__uIPHn","notes":"_NotesList_notes__28qE2","chart":"_NotesList_chart__349CY"};